export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'de'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/** Locales exposed in the language selector UI */
export const SELECTABLE_LOCALES = ['en', 'de'] as const;
export type SelectableLocale = (typeof SELECTABLE_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';
export const LOCALE_STORAGE_KEY = 'toyo-locale';

export function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/** Resolve locale from stored preference, then browser language, then default. */
export function resolveInitialLocale(): SupportedLocale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && isSupportedLocale(stored)) {
      return stored;
    }
  } catch {
    // localStorage may be unavailable (SSR, private mode)
  }

  const browser = navigator.language?.split('-')[0];
  if (browser && isSupportedLocale(browser)) {
    return browser;
  }

  return DEFAULT_LOCALE;
}
